import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getPlaceToVisit } from "../../services/HomeServices";
import Loader from "../../containers/Loader";
import SideADModule from "../../containers/PostCards/SideADModule";
import _ from "lodash";
import SliderCom from "../Helpers/SliderCom";

const MainSection = () => {
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  // const [catData, setcatData] = useState([]);
  const [selectedItem, setselectedItem] = useState({});
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();

  const SliderForImage = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
    fade: true,
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setisLoading(true);
    await getPlaceToVisit()
      .then((response) => {
        setdata(response?.data?.data);
        setselectedItem(response?.data?.data[0]);
        setisLoading(false);
      })
      .catch((error) => {
        setisLoading(true);
        toast("Something went wrong", { type: "error" });
      });
  };

  return (
    <section
      className={`binduz-er-latest-news-area `}
      style={{ paddingTop: "30px" }}
    >
      <div className=" container">
        <div className="row">
          {/* <Breadcrumb title="Place To Visit" /> */}
          {!isLoading && (
            <div
              className=" col-lg-3"
              // style={{ paddingRight: "85px", paddingLeft: "55px" }}
            >
              <div className="binduz-er-top-news-title">
                <h3 className="binduz-er-title">
                  <i
                    className="far fa-archway"
                    style={{ color: "#FF6821", marginRight: "5px" }}
                  ></i>
                  PLACE TO VISIT
                </h3>
              </div>
              <div className="binduz-er-social-list">
                <div className="binduz-er-list">
                  {data?.map((x) => (
                    <a
                      className="category-search"
                      onClick={() => {
                        setselectedItem(x);
                      }}
                    >
                      <span>
                        <span
                          style={{
                            color: `${
                              selectedItem?.id === x?.id ? "#FF6821" : ""
                            }`,
                            cursor: "pointer",
                          }}
                        >
                          {x?.place}
                        </span>
                      </span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          )}
          {!isLoading ? (
            <div
              className=" col-lg-6"
              style={{ paddingRight: "40px", paddingLeft: "40px" }}
            >
              <div className="binduz-er-content">
                <div className="binduz-er-meta-item">
                  {/* <div className="binduz-er-meta-categories">
                  <a href="#">Technology</a>
                </div> */}
                  <div className="binduz-er-meta-date">
                    <span>
                      {/* <i className="fal fa-calendar-alt"></i>24th February 2020 */}
                    </span>
                  </div>
                </div>
                <h3 className="binduz-er-title">
                  {/* <a>{selectedItem?.place}</a> */}
                  <div className="binduz-er-top-news-title">
                    <h3 className="binduz-er-title">{selectedItem?.place}</h3>
                  </div>
                </h3>
                {/* {!_.isEmpty(selectedItem?.image) && (
                  <img
                    src={selectedItem?.image[0]?.image}
                    alt="BannerImage"
                    className="img-fluid  shadow mt-4 p-1"
                    style={{
                      borderRadius: "20px",
                      width: "100%",
                      height: "45vh",
                      // objectFit:'contain',
                      // backgroundColor: "black",
                      // border: "1px solid black",
                    }}
                  />
                )} */}
                {!_.isEmpty(selectedItem?.image) && (
                  <div
                    style={{
                      paddingLeft: "25px",
                      paddingRight: "25px",
                      paddingTop: "5px",
                      paddingBottom: "15px",
                    }}
                  >
                    <SliderCom
                      settings={SliderForImage}
                      asNavFor={nav2}
                      selector={(slider1) => setNav1(slider1)}
                    >
                      {selectedItem?.image?.map((x) => (
                        <div>
                          <div
                            className="binduz-er-item"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div>
                              <img
                                className="img-fluid  shadow"
                                src={x?.image}
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                  // objectFit: "contain",
                                  backgroundColor: "white",
                                  height: "45vh",
                                  // border: "1px solid black",
                                }}
                                alt="img"
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </SliderCom>
                  </div>
                )}
                <div className="binduz-er-text mt-4">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: selectedItem?.description,
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div style={{ marginTop: "101px" }} className=" col-lg-9">
              <Loader />
            </div>
          )}
          <div className="col-lg-3">
            <SideADModule isClassifield={true} isEvent={true} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainSection;
